import styled from 'styled-components';

import FormText from '@klv/atoms/form-text';
import type { TColorVariant } from '@klv/shared/styles/types';

const FieldGroup = styled.div`
  position: relative;
`;

const Label = styled.label<{ $backgroundColor: TColorVariant; }>`
  color: ${({ theme, $backgroundColor }) => theme.form[$backgroundColor].label};
  cursor: pointer;
  margin-bottom: .5rem;
  ${({ theme }) => theme.fonts.sohne.regular}
  font-size: 1.4rem;
  line-height: 1.42;
`;

const Description = styled.div<{ $backgroundColor: TColorVariant; }>`
  color: ${({ theme, $backgroundColor }) => theme.form[$backgroundColor].label};
  margin-bottom: .5rem;
  font-size: 1.2rem;
  ${({ theme }) => theme.fonts.sohne.regular}
`;

const Input = styled.input<{ hasError: boolean; $backgroundColor: TColorVariant; multiple?: boolean; }>`
  width: 100%;
  height: ${({ multiple }) => `${multiple ? '9.3rem' : '100%'}`};
  border: .2rem solid ${({ theme, $backgroundColor }) => theme.form[$backgroundColor].fieldBorder};
  padding: 1.6rem 1.2rem;
  border-radius: 0.6rem;
  margin-bottom: 2.5rem;
  ${({ theme, $backgroundColor }) => (`
    color: ${theme.form[$backgroundColor].inputText};
    ${theme.fonts.sohne.regular}
    box-shadow: ${theme.form[$backgroundColor].fieldBoxShadow};
    background: ${theme.form[$backgroundColor].fieldBackground};
    font-size: 1.4rem;
    ::placeholder {
      ${theme.fonts.sohne.regular}
      font-size: 1.4rem;
      color: ${theme.form[$backgroundColor].placeholderText};
    }
  `)}
  ${({ hasError, theme, $backgroundColor }) => hasError && `border-color:${theme.form[$backgroundColor].error}!important; margin-bottom: 0;`}

  &:focus {
    outline: none;
    ${({ theme, $backgroundColor }) => (`
      background: ${theme.form[$backgroundColor].fieldBackgroundFocus};
      border: .2rem solid ${theme.form[$backgroundColor].fieldBorder ? theme.form[$backgroundColor].fieldBorder : 'rgba(255, 255, 255, 0)'};
    `)}
  }
`;

const Textarea = styled.textarea<{ hasError: boolean; $backgroundColor: TColorVariant; }>`
  width: 100%;
  border: .2rem solid ${({ theme, $backgroundColor }) => theme.form[$backgroundColor].fieldBorder};
  padding: 1.2rem;
  border-radius: 0.6rem;
  margin-bottom: 2.5rem;
  ${({ theme, $backgroundColor }) => (`
    color: ${theme.form[$backgroundColor].inputText};
    ${theme.fonts.sohne.regular}
    box-shadow: ${theme.form[$backgroundColor].fieldBoxShadow};
    background: ${theme.form[$backgroundColor].fieldBackground};
    font-size: 1.4rem;
    ::placeholder{
      ${theme.fonts.sohne.regular}
      font-size: 1.4rem;
      color: ${theme.form[$backgroundColor].placeholderText};
    }
  `)}
  ${({ hasError, theme, $backgroundColor }) => hasError && `border-color:${theme.form[$backgroundColor].error}; margin-bottom: 0;`}

  &:focus {
    outline: none;
    ${({ theme, $backgroundColor }) => (`
      background: ${theme.form[$backgroundColor].fieldBackgroundFocus};
      border: .2rem solid ${theme.form[$backgroundColor].fieldBorder ? theme.form[$backgroundColor].fieldBorder : 'rgba(255, 255, 255, 0)'};
    `)}
  }
`;

const Error = styled(FormText)<{ $backgroundColor: TColorVariant; }>`
  color: ${({ theme, $backgroundColor }) => theme.form[$backgroundColor].error};
  user-select: none;
  margin-bottom: 1.7rem;
  margin-top: 0.8rem;
`;

export {
  FieldGroup, Label, Description, Input, Error, Textarea,
};
